import type { FaireProductEntity } from "../../entity_types/product";

export const p_53dpq4qmy8: FaireProductEntity = {
  token: "p_53dpq4qmy8",
  type: "product",
  name: "Jumpstart - 12oz - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/9477273e78558a25087666f809b4e34fedf406029f244bd2794bdfc60fdc21c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0160630e03ece014337631a6d2e100b428c935c7e083b51a4d242e6d19699093.jpeg",
    "https://cdn.faire.com/fastly/9bf9d13a9c1a977bd02ea1b3bc8fffd67ac7ab3019d89a4eaf243e543b80956e.jpeg",
    "https://cdn.faire.com/fastly/f4255a56b86398eeea413075c8594809fe6492a142d90e8eb22ddf3a18737e55.jpeg",
    "https://cdn.faire.com/fastly/c07aa9fa05be4735ff41a8c0b9d76754d3ccf8ec5bf36569fd9af7d72391dc20.jpeg",
  ],
  priceDollars: 10.92,
  description:
    "The newest addition to our mainstay lineup, Jumpstart is a versatile blend of Latin American coffees with a rich, decadent flavor profile. Jumpstart is full-bodied, with caramel sweetness and notes of Jordan almond and poached pear.\n\nThis coffee presents beautifully in both espresso and filter preparations.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Sources Various\n• Tasting Notes Caramel, Jordan Almonds, and Poached Pear\n• Region Latin America\n• Process Wet-Processed\n\nPerfect For: Father's Day gifting",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:11.072Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
